import { isSkillup } from '../../../lib/config/project/project';
import useLocalSalaryData from '../../../lib/hooks/localSalaryData';
import { useAuth } from '../../../lib/providers/authProvider';
import { useRegion } from '../../../lib/providers/regionProvider';
import Video from '../../careers/Video';
import ReadMore from '../../training/ReadMore';
import WageData from '../WageData';

interface CareerJobAndWageInfoProps {
  career: any;
}

const CareerJobAndWageInfo: React.FC<CareerJobAndWageInfoProps> = ({
  career,
}) => {
  const { seeker } = useAuth();
  const {
    region: fullRegion,
    region: { name: regionName },
  } = useRegion();
  const {
    medianAnnualSalary,
    entryAnnualSalary,
    entryHourlyWage,
    medianHourlyWage,
    highAnnualSalary,
    highHourlyWage,
  } = useLocalSalaryData(career.onetCode, career, seeker, fullRegion.location);
  return (
    <>
      <Video career={career} />
      {career.tasks.length && (
        <section className="my-10 md:my-18">
          <h2
            className={`${
              isSkillup
                ? 'text-3xl font-bold md:text-4xl font-heading'
                : 'text-2xl font-semibold md:text-4xl leading-heading2 text-careerPageHeading'
            }`}
          >
            What is this job like?
          </h2>
          <ReadMore
            heightClass="max-h-80"
            borderClass="border-careerPageHeading"
            colorClass="text-careerPageHeading"
            gradientClass="bg-offGrayGradient"
            bgClass="bg-off-gray"
            chevronColorClass="stroke-careerPageHeading"
          >
            <ul className="mx-4 my-8 list-disc md:mx-8 md:my-10">
              {career.tasks.map((task: any, index: number) => (
                <li
                  key={`destination-${index}`}
                  className={`${
                    isSkillup && 'my-2 font-sans text-xl leading-6 list-disc'
                  }"my-2 leading-6 list-disc"`}
                >
                  {task.description}
                </li>
              ))}
            </ul>
          </ReadMore>
        </section>
      )}
      <section className="my-10 md:my-18">
        <h2
          className={`${
            isSkillup
              ? 'text-3xl font-bold md:text-4xl font-heading'
              : 'text-2xl font-semibold md:text-4xl leading-heading2 text-careerPageHeading'
          }`}
        >
          Local Wage Data
        </h2>
        <section className="my-6 md:my-10">
          <WageData
            entryAnnualSalary={entryAnnualSalary}
            entryHourlyWage={entryHourlyWage}
            medianAnnualSalary={medianAnnualSalary}
            medianHourlyWage={medianHourlyWage}
            highAnnualSalary={highAnnualSalary}
            highHourlyWage={highHourlyWage}
            textColorClass={`${
              isSkillup ? 'text-training' : 'text-gnoIncMdBlue'
            }`}
            borderRadiusClass="rounded-2xl"
            region={`${isSkillup ? regionName : ''}`}
          />
        </section>
      </section>
    </>
  );
};

export default CareerJobAndWageInfo;
